import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard } from 'app/core/auth.guard';
import { PendingChangesGuard } from 'app/core/pending-changes.guard';
import { PrepareGuard } from 'app/core/prepare.guard';
import { SharedModule } from 'app/shared/shared.module';
import { LookupTableComponent } from './lookup-table/lookup-table.component';
import { ProductLocationDialogComponent } from './product-location-dialog/product-location-dialog.component';
import { ProductUomDialogComponent } from './product-uom-dialog/product-uom-dialog.component';
import { UserOverviewComponent } from './user-overview/user-overview.component';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { StatementOverviewComponent } from './statement-overview/statement-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'admin',
                canActivate: [AuthGuard, PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    { path: 'lookup-tables', component: LookupTableComponent, data: { title: 'Lookup Tables' }, canDeactivate: [PendingChangesGuard] },
                    { path: 'users', component: UserOverviewComponent, data: { title: 'Users' } },
                    { path: 'statements', component: StatementOverviewComponent, data: { title: 'Statements' } },
                ],
            },
        ]),
    ],
    declarations: [LookupTableComponent, ProductUomDialogComponent, ProductLocationDialogComponent, UserOverviewComponent, UserDialogComponent, StatementOverviewComponent],
})
export class AdminModule {}
